import { useTasks, taskActions, useTaskInvalidate, statusPill } from "../hooks/useTasks";
import type { TaskItem } from "../lib/types";

function trayDate(ts?: string): string {
  if (!ts) return "";
  return new Date(ts + "Z").toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function TasksModal({
  open,
  onClose,
  onOpenDetail,
}: {
  open: boolean;
  onClose: () => void;
  onOpenDetail: (task: TaskItem) => void;
}) {
  const { data: tasks = [] } = useTasks(open);
  const invalidate = useTaskInvalidate();
  const actions = taskActions(invalidate);

  return (
    <div
      className={`tasks-modal${open ? " show" : ""}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="tasks-modal-content">
        <div className="tasks-modal-header">
          <span className="tasks-modal-title">Tasks</span>
          <div className="tasks-modal-header-actions">
            <button
              className="tasks-mark-all-done"
              onClick={async () => {
                await Promise.all(tasks.map((t) => actions.done(t.id).catch(() => {})));
                invalidate();
              }}
            >
              Done All
            </button>
            <span className="tasks-modal-close" onClick={onClose}>
              &times;
            </span>
          </div>
        </div>
        <div className="tasks-modal-body" id="tasksListContainer">
          {tasks.length === 0 ? (
            <div className="tasks-tray-empty">No open tasks</div>
          ) : (
            tasks.map((t) => {
              const pill = statusPill(t);
              const note = t.task_note ? (t.task_note.length > 100 ? t.task_note.substring(0, 100) + "..." : t.task_note) : "";
              return (
                <div className="tasks-tray-item" key={t.id} onClick={() => onOpenDetail(t)}>
                  <div className="tasks-tray-item-content">
                    <div className="tasks-tray-item-name">
                      {t.customer_name || "Unknown"}
                      {pill && <span className={`task-status-pill ${pill.cls}`}> {pill.label}</span>}
                    </div>
                    {note && <div className="tasks-tray-item-note">{note}</div>}
                    <div className="tasks-tray-item-date">{trayDate(t.created_at)}</div>
                    {t.source === "email-triage" && <div className="tasks-tray-item-source">via email triage</div>}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 4, alignSelf: "center" }}>
                    <button
                      className="tasks-tray-item-done"
                      onClick={(e) => {
                        e.stopPropagation();
                        actions.done(t.id);
                      }}
                    >
                      done
                    </button>
                    <button
                      className="tasks-tray-item-dismiss"
                      onClick={(e) => {
                        e.stopPropagation();
                        actions.dismiss(t.id);
                      }}
                    >
                      dismiss
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>
        <div className="tasks-modal-footer">
          <a href="/emails" className="tasks-modal-view-all">
            View all emails &rarr;
          </a>
        </div>
      </div>
    </div>
  );
}
